import { jsonapiModule as jsonapiModuleZen } from 'json-api-zen'

const config = {
  preserveJson: true,
  clearOnUpdate: true,
}
export default function ({ $axios, store }) {
  store.registerModule('jvZen', jsonapiModuleZen($axios, config))
}
